import React from "react";

export function Input(props) {
  return (    
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="18.051" height="17.897" viewBox="0 0 18.051 17.897">
    <defs>
      <clipPath id="clipPath">
        <rect id="Retângulo_178" data-name="Retângulo 178" width="18.051" height="17.897" transform="translate(0 0.001)" fill={"white"}/>
      </clipPath>
    </defs>
    <g id="Grupo_316" data-name="Grupo 316" transform="translate(0 -0.001)">
      <g id="Grupo_315" data-name="Grupo 315" clipPath="url(#clipPath)">
        <path id="Caminho_395" data-name="Caminho 395" d="M13.838,17.9H1a1,1,0,0,1-1-1V4.06a1,1,0,0,1,1-1H6.627a1,1,0,0,1,0,2H2V15.9H12.838V11.156a1,1,0,0,1,2,0V16.9a1,1,0,0,1-1,1" fill={"white"}/>
        <path id="Caminho_396" data-name="Caminho 396" d="M16.4,0H13.076a1,1,0,0,0,0,2h1.56L6.789,9.849A1,1,0,1,0,8.2,11.263L16.05,3.414V4.976a1,1,0,0,0,2,0V1.652A1.654,1.654,0,0,0,16.4,0" transform="translate(-3.212 3.06)" fill={"white"}/>
      </g>
    </g>
  </svg>
  )  
}

export function InputHover(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="18.051" height="17.897" viewBox="0 0 18.051 17.897">
      <defs>
        <clipPath id="clipPath">
          <rect id="Retângulo_178" data-name="Retângulo 178" width="18.051" height="17.897" transform="translate(0 0.001)" fill={"white"}/>
        </clipPath>
      </defs>
      <g id="Grupo_316" data-name="Grupo 316" transform="translate(0 -0.001)">
        <g id="Grupo_315" data-name="Grupo 315" clipPath="url(#clipPath)">
          <path id="Caminho_395" data-name="Caminho 395" d="M13.838,17.9H1a1,1,0,0,1-1-1V4.06a1,1,0,0,1,1-1H6.627a1,1,0,0,1,0,2H2V15.9H12.838V11.156a1,1,0,0,1,2,0V16.9a1,1,0,0,1-1,1" fill={"white"}/>
          <path id="Caminho_396" data-name="Caminho 396" d="M16.4,0H13.076a1,1,0,0,0,0,2h1.56L6.789,9.849A1,1,0,1,0,8.2,11.263L16.05,3.414V4.976a1,1,0,0,0,2,0V1.652A1.654,1.654,0,0,0,16.4,0" transform="translate(-1.212 1.06)" fill={"white"}/>
        </g>
      </g>
    </svg>
  )  
}

export function Cloud(props) {
  const color = props.color;
  return (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24.037" height="25.775" viewBox="0 0 24.037 25.775">
    <defs>
      <clipPath id="clipPath">
        <rect id="Retângulo_165" data-name="Retângulo 165" width="24.037" height="25.775" fill="none" stroke={color} strokeWidth="1"/>
      </clipPath>
    </defs>
    <g id="Ico_baixar" transform="translate(24.037 25.775) rotate(180)">
      <g id="Grupo_273" data-name="Grupo 273" transform="translate(24.037 25.775) rotate(180)">
        <g id="Grupo_272" data-name="Grupo 272" transform="translate(0 0)" clipPath="url(#clipPath)">
          <path id="Caminho_371" data-name="Caminho 371" d="M16.131,18.519a6.283,6.283,0,0,0,0-12.565h-.179a5.722,5.722,0,0,0-11.395.629,6.27,6.27,0,0,0,2.7,11.936" transform="translate(0.326 0.326)" fill="none" stroke={color} strokeLinecap="square" strokeLinejoin="round" strokeWidth="1.941"/>
          <path id="Caminho_372" data-name="Caminho 372" d="M6.184,11.256l3.14-3.14a.871.871,0,0,1,1.231,0l3.14,3.14" transform="translate(2.079 2.642)" fill="none" stroke={color} strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.941"/>
          <line id="Linha_20" data-name="Linha 20" y2="13.62" transform="translate(12.018 10.859)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.941"/>
        </g>
      </g>
    </g>
  </svg>
  )
}

export function CloudHover(props) {
  const color = props.color;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24.037" height="25.775" viewBox="0 0 24.037 25.775">
  <defs>
    <clipPath id="clipPath">
      <rect id="Retângulo_165" data-name="Retângulo 165" width="24.037" height="25.775" fill="none" stroke={color} strokeWidth="1"/>
    </clipPath>
  </defs>
  <g id="Ico_baixar" transform="translate(24.037 25.775) rotate(180)">
    <g id="Grupo_273" data-name="Grupo 273" transform="translate(24.037 25.775) rotate(180)">
      <g id="Grupo_272" data-name="Grupo 272" transform="translate(0 0)" clipPath="url(#clipPath)">
        <path id="Caminho_371" data-name="Caminho 371" d="M16.131,18.519a6.283,6.283,0,0,0,0-12.565h-.179a5.722,5.722,0,0,0-11.395.629,6.27,6.27,0,0,0,2.7,11.936" transform="translate(0.326 0.326)" fill="none" stroke={color} strokeLinecap="square" strokeLinejoin="round" strokeWidth="1.941"/>
        <path id="Caminho_372" data-name="Caminho 372" d="M6.184,11.256l3.14-3.14a.871.871,0,0,1,1.231,0l3.14,3.14" transform="translate(2.079 0.642)" fill="none" stroke={color} strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.941"/>
        <line id="Linha_20" data-name="Linha 20" y2="13.62" transform="translate(12.018 8.859)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.941"/>
      </g>
    </g>
  </g>
</svg>
  )
}

export function Download(props) {
  const color = props.color;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14.303" height="22.451" viewBox="0 0 14.303 22.451">
      <g id="Ico_baixar" transform="translate(1 1)">
        <g id="Grupo_120" data-name="Grupo 120" transform="translate(-1813.582 -876.668)">
          <path id="Caminho_340" data-name="Caminho 340" d="M1.886-2.717v2.5h12.3v-2.5" transform="translate(1811.696 897.332)" fill="none" stroke={color} strokeLinecap="round" strokeWidth="2"/>
          <line id="Linha_13" data-name="Linha 13" y2="11.542" transform="translate(1819.734 876.668)" fill="none" stroke={color} strokeLinecap="round" strokeWidth="2"/>
        </g>
        <path id="Caminho_153" data-name="Caminho 153" d="M1812.22,4577.534l4.715,4.715,4.715-4.715" transform="translate(-1810.784 -4570.34)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
      </g>
    </svg>
  )
}

export function DownloadHover(props) {
  const color = props.color;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14.303" height="17.451" viewBox="0 0 14.303 17.451">
      <g id="Ico_baixar" transform="translate(1 1)">
        <g id="Grupo_120" data-name="Grupo 120" transform="translate(-1813.582 -881.668)">
          <path id="Caminho_340" data-name="Caminho 340" d="M1.886-2.717v2.5h12.3v-2.5" transform="translate(1811.696 897.332)" fill="none" stroke={color} strokeLinecap="round" strokeWidth="2"/>
          <line id="Linha_13" data-name="Linha 13" y2="11.542" transform="translate(1819.734 881.668)" fill="none" stroke={color} strokeLinecap="round" strokeWidth="2"/>
        </g>
        <path id="Caminho_153" data-name="Caminho 153" d="M1812.22,4577.534l4.715,4.715,4.715-4.715" transform="translate(-1810.784 -4570.34)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
      </g>
    </svg>
  )
}

export function AnimationButton(props) {
  const rotate = props.rotate ?? "0";
  return (
    <img src="assets/arrowcircle.png" style={{width: '28px', height: '28px', transform: `rotate(${rotate}deg)`}} />
  )
}

export function AnimationButton2(props) {
  const rotate = props.rotate ?? "0";
  return (
    <img src="assets/arrowblue.png" style={{width: '28px', height: '28px', transform: `rotate(${rotate}deg)`}} />
  )
}

export function AnimationButton3(props) {
  const rotate = props.rotate ?? "0";
  return (
    <img src="assets/arrowpink.png" style={{width: '28px', height: '28px', transform: `rotate(${rotate}deg)`}} />
  )
}